import { render, staticRenderFns } from "./EditUniRequest.vue?vue&type=template&id=0a9f06e6&"
import script from "./EditUniRequest.vue?vue&type=script&lang=js&"
export * from "./EditUniRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports